/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import {Tabs , Tab } from 'react-bootstrap'
import contentService from '../../../../services/content-service';
import VocabContent from '../../../../components/wizards/assignments/vocab_content'
import Translations from '../../../../store/internationalization-store'

class VocabsPanel extends React.Component {

    constructor(props) {
        super();

        this.props = props;
        this.initalComment = false;
        this.feedback = {};
        this.slice = 0;
        this.state = {
            stuff:false,
            contentData:[],
            tabTitle:[]
        }
    }

    getVocabData(uid, ietf, id, translation){

        console.log("hello")

        contentService.getVocabTranslation(null, ietf , uid).then(function(data) {
            var contentData = this.state.contentData;
            contentData[id] = data.vocabTranslations;
            var tabTitle = this.state.tabTitle;
            tabTitle[id] = data.customTitle;
            this.setState({selectedType:"vocabs", contentData:contentData, tabTitle:tabTitle});
        }.bind(this));

    }


    componentDidMount(){
        var tasks = this.props.data.homework.tasks;
        var counter = 0;
        var catalogList = [];
        for (var i = 0; i < this.props.data.homework.tasks.length; i++) {
            if (tasks[i].feature_uid == 6) {
                if (!catalogList.includes(tasks[i].rel_module_uid)) {
                    catalogList.push(tasks[i].rel_module_uid);
                    this.getVocabData(tasks[i].rel_module_uid,this.props.data.homework.languageCode, counter,Translations.get(649 , 'My Content'));
                    counter++;
                }

            }
        }
    }

    generateTabs() {
        var tabs = [];
        for (var i= 0; i < this.state.contentData.length; i++) {
            tabs.push(<Tab eventKey={"vocabTab"+i} title={this.state.tabTitle[i]}>
                <VocabContent vocabTranslations={this.state.contentData[i]}></VocabContent>
            </Tab>)

        }

        return tabs;
    }


    render(){
        if (this.state.contentData == undefined) {
            return ""
        }

        return <div style={{paddingTop:"10px"}} className="pmbb-body">
            <Tabs
                id="controlled-tab-example"
                activeKey={this.state.key}
                onSelect={key => this.setState({ key })}
                style={{marginBottom:"0px", marginLeft:"0px"}}>
                {this.generateTabs()}
            </Tabs>
            
        </div>;
    }
}




export default {
    name: function() {return <span>{Translations.get(12207 , 'Custom Content')}</span>} ,
    component: VocabsPanel
}